import { render, staticRenderFns } from "./VideosTutoriales.vue?vue&type=template&id=709e943c&"
import script from "./VideosTutoriales.vue?vue&type=script&lang=js&"
export * from "./VideosTutoriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports